import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function ThanksPage() {
  const navigate = useNavigate();

  const { state } = useLocation();
  const booking = state?.bookingRes;

  return (
    <div className="thanks-page-bg">
      <div className="thanks-page-content">
        <div className="thanks-card">
          <div className="thanks-icon">
            { !booking ? <i className="fa-solid fa-xmark"></i> :   <i className="fa-solid fa-check"></i> }
          </div>

          {!booking ? (
            <h3>No booking data found</h3>
          ) : (
            <>
              <h2 className="thanks-title">Your Order is Confirmed!</h2>

              <p className="thanks-subtitle">
                We’ll send you a shipping confirmation once your order is
                dispatched.
              </p>

              <button
                className="thanks-btn"
                onClick={() => navigate("/auth/profile")}
              >
                Check Status
              </button>

              <div className="thanks-page-order-sm-text-container">
                <p>
                  <h4> Order updates </h4>
                </p>
                <p>You may get shipping and delivery updates by text.</p> <br />
                <p>
                  <h4>
                 
                    Total Ammount - Rs.{booking?.TotalAmmount.totalPayable}
                  </h4>
                </p>
                <p> Order_ID : {booking?.bookingId}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ThanksPage;
